import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {of} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RegioLockUserService {
    private URL: string = '/api/sensor';
    constructor(private httpService: HttpClient) {}

    getSensorValues(startDate: string, endDate: string, storageLocationId: string) {
        if(!storageLocationId) {return of(false);}
        return this.httpService.get(
            `${this.URL}/sensorValues/${storageLocationId}?startDate=${startDate}&endDate=${endDate}`,
        );
    }

    getDeviceStatus(storageLocationId: string) {
        if(!storageLocationId) {return of(false);}
        return this.httpService.get(`/api/regio-lock/deviceStatus/${storageLocationId}`);
    }
}
